import { message } from 'antd'
import { fetchUtil as fetch } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'

export const getGamesCategory = async () => {
  try {
    const { data } = await fetch('/metaverse-rooms/games/categories')
    return data
  } catch (e) {
    message.error('Get Games Category error!')
  }
}

export const getGamesByCategory = async (page, size, title = '') => {
  try {
    const { data } = await fetch('/metaverse-rooms/games/searchAdmin', {
      method: 'POST',
      body: JSON.stringify({
        size: size,
        page: page,
        name: title,
      }),
      headers: {
        role: 'ADMIN',
      },
    })
    return data
  } catch (e) {
    message.error('Search Games Error !')
  }
}

export const saveEditGames = async (
  id,
  title,
  titleFr,
  desc,
  descFr,
  descAr,
  instruction,
  instructionFr,
  instructionAr,
  img,
  thumbImage,
  categories,
  accessLevels,
  enabled,
  complex,
  retentionDepth,
  monetizationModel,
  tier,
  splashImage
) => {
  try {
    const input = new FormData()
    input.append(
      'gameEditDto',
      new Blob(
        [
          JSON.stringify({
            id: id,
            title: title,
            titleFr: titleFr,
            description: desc,
            descriptionFr: descFr,
            descriptionAr: descAr,
            categories: categories,
            accessLevels: accessLevels,
            enabled: enabled,
            instruction: instruction,
            instructionFr: instructionFr,
            instructionAr: instructionAr,
            complex: complex,
            retentionDepth: retentionDepth,
            monetizationModel: monetizationModel,
            tier: tier
          }),
        ],
        {
          type: 'application/json',
        }
      )
    )
    input.append('image', img)
    input.append('thumbImage', thumbImage)
    if (splashImage) {
      
      input.append('splashImage', splashImage)
    }

    const { data } = await fetch('/metaverse-rooms/games/edit', {
      method: 'POST',
      body: input,
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('EDIT', 'GAME', id)
    message.success('Success Games Room Edit!')
    return 'success'
  } catch (e) {
    message.error('Edit Games Room error!')
    return 'failed'
  }
}
export const getByCategories = async () => {
  try {
    const res = await fetch(`/metaverse-rooms/games/game-categories`)
    if (Array.isArray(res?.data)) {
      const validTypes = new Set([
        'CARDS',
        'PUZZLE',
        'QUIZ',
        'ACTION',
        'ADVENTURE',
        'SPORTS',
      ])
      const filtered = res.data.filter((room) => validTypes.has(room.type))
      return filtered
    }
    throw 'Get all categories response wrong format'
  } catch (e) {
    message.error('getAll categories error ')
  }
}
export const updateGamesOrder = async (
  categoryId: string,
  updatedCategory: GamesCategory
) => {
  try {
    await fetch(`/metaverse-rooms/games/sort/${categoryId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedCategory),
    })
    saveAuditData('EDIT', 'GAMEORDER', categoryId)
  } catch (e) {
    message.error('update Games Order error ')
  }
}

export const getByCategoriesAll = async () => {
  try {
    const { data } = await fetch(`/metaverse-rooms/games/game-categories`)

    return data
  } catch (e) {
    message.error('get Games By All categories error ')
  }
}

export const getTopUser = async (id, country) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/games/top/${id}/admin/${country}`
    )
    return data
  } catch (e) {
    message.error('Leaderboard Game Error !')
  }
}
